import api from '@e74/services/ApiConfig';
import {fetchError, hideMessage, fetchStart, fetchSuccess} from '../Common';

export const ACTION_TYPES = {
  CREATE: 'CREATE_PERIOPERATIVE_MESSAGE_TEMPLATE',
  UPDATE: 'UPDATE_PERIOPERATIVE_MESSAGE_TEMPLATE',
  DELETE: 'DELETE_PERIOPERATIVE_MESSAGE_TEMPLATE',
  FETCH_ALL: 'FETCH_ALL_PERIOPERATIVE_MESSAGE_TEMPLATE',
  SET_CURRENT_TEMPLATE_ID:
    'SET_PERIOPERATIVE_MESSAGE_TEMPLATE_CURRENT_TEMPLATE_ID',
};

export const fetchAll = (category = null) => (dispatch) => {
  dispatch(fetchStart());
  const apiCall = category
    ? api.perioperativemessagetemplates().fetchByCategory(category)
    : api.perioperativemessagetemplates().fetchAll();
  
  apiCall
    .then((response) => {
      dispatch({
        type: ACTION_TYPES.FETCH_ALL,
        payload: response.data,
      });
      dispatch(fetchSuccess());
      dispatch(hideMessage());
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const create = (data, onSuccess) => (dispatch) => {
  dispatch(fetchStart());
  api
    .perioperativemessagetemplates()
    .create(data)
    .then((response) => {
      dispatch({
        type: ACTION_TYPES.CREATE,
        payload: response.data,
      });
      dispatch(fetchSuccess());
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const update = (id, data, onSuccess) => (dispatch) => {
  dispatch(fetchStart());
  api
    .perioperativemessagetemplates()
    .update(id, data)
    .then((response) => {
      dispatch({
        type: ACTION_TYPES.UPDATE,
        payload: {id, ...data},
      });
      dispatch(fetchSuccess());
      onSuccess();
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const Delete = (id) => (dispatch) => {
  dispatch(fetchStart());
  api
    .perioperativemessagetemplates()
    .delete(id)
    .then((res) => {
      dispatch({
        type: ACTION_TYPES.DELETE,
        payload: id,
      });
      dispatch(fetchSuccess());
    })
    .catch((err) =>
      err.response !== undefined
        ? dispatch(fetchError(err.response.data.error))
        : dispatch(fetchError(err)),
    );
};

export const setCurrentTemplateId = (templateId) => (dispatch) => {
  dispatch({type: ACTION_TYPES.SET_CURRENT_TEMPLATE_ID, payload: templateId});
};
